import { useEffect, useRef } from 'react'

/**
 * Scrolls the returned ref's element to the far right whenever the set of
 * column keys changes. Tracks the previously scrolled key-set so background
 * refetches that return the same columns (with a new array reference) do not
 * re-trigger the scroll and yank the user back to the right mid-browse.
 */
export function useScrollToEndOnColumnChange<T extends { key: string }>(
  columns: readonly T[]
) {
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const lastColumnSetKeyRef = useRef<string | null>(null)

  useEffect(() => {
    if (columns.length === 0) return
    const key = columns.map((c) => c.key).join('|')
    if (lastColumnSetKeyRef.current === key) return
    lastColumnSetKeyRef.current = key
    const el = scrollContainerRef.current
    if (!el) return
    el.scrollLeft = el.scrollWidth
  }, [columns])

  return scrollContainerRef
}
